export {default as hexbin} from "./src/hexbin";



//////////////////
// WEBPACK FOOTER
// ./~/d3-hexbin/index.js
// module id = 267
// module chunks = 0